import React, { Component } from 'react'

class ProposalSectionLinesPreview extends Component {
  renderItem = (item, type) => {
    return (
      <li key={item.id || item.tmpId}>
        {item.description}
        {item.items && (
          <ol type={type === 'roman' ? '1' : 'I'}>
            {item.items.map(item => this.renderItem(item, type === 'roman' ? '1' : 'I'))}
          </ol>
        )}
      </li>
    )
  }

  render() {
    const { proposalItems } = this.props

    if (proposalItems && Object.keys(proposalItems).length) {
      return <ol type="I">{proposalItems.map(item => this.renderItem(item, 'roman'))}</ol>
    } else {
      return <ol>No items</ol>
    }
  }
}

export default ProposalSectionLinesPreview



// WEBPACK FOOTER //
// ./src/components/templates/ProposalSectionLinesPreview.js